var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"to":{ name: 'Student', params: { id: _vm.studentId } },"title":"Þátttakandi skráður í hóp. Breyttu upplýsingum á þátttakandaspjaldi."}},[_c('i',{staticClass:"fa fa-fw fa-external-link"})])
}
var staticRenderFns = []

export { render, staticRenderFns }